module.exports = __webpack_public_path__ + "img/approvals.43ee7d1d.svg";